import React from "react";
import { createUseStyles } from "react-jss";
import { THEME } from "../../theming/theming";
export function TableEmpty(props) {
    var _a;
    var classes = useTableEmptyClasses();
    return (React.createElement("div", { className: classes.noResult, role: "row", "data-rowindex": "0", "aria-rowindex": 1 },
        React.createElement("p", { role: "cell", "aria-colindex": 1, "data-colindex": "0", className: classes.text }, (_a = props.noDataText) !== null && _a !== void 0 ? _a : "No Results")));
}
var useTableEmptyClasses = function () {
    var useStyles = createUseStyles({
        noResult: {
            padding: 8,
            textAlign: "center",
            backgroundColor: THEME.palette.gray.white.color,
            "> p": {
                marginBottom: 0,
            },
        },
        text: {
            marginBottom: 0,
        },
    });
    return useStyles();
};
